import {
  Paper,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { formatDateTimeWithSeconds } from '../../utils/DateTimeUtils';

//Common styles
import {
  CustomTableRowTR,
  StyledTable,
  TableData,
  TableHeader,
  TableTopHeader,
  TableWrapper,
  Title,
} from "../../styles/commonStyles";

const PartyCommentsPanel = ({ record }: { record: any }) => {
  return (
    <TableWrapper>
      <TableTopHeader>
        <Title>Allocator comments</Title>
      </TableTopHeader>

      <TableContainer component={Paper} sx={{ borderRadius: "8px" }}>
        <StyledTable>
          <TableHead>
            <TableRow
              sx={{
                backgroundColor: "rgba(232, 235, 237, 0.3) !important",
              }}
            >
              <TableHeader>Comment</TableHeader>
              <TableHeader>Commenter email</TableHeader>
              <TableHeader>Timestamp</TableHeader>
            </TableRow>
          </TableHead>
          <TableBody>
            {record?.allocatorComments?.length > 0 ? (
              record?.allocatorComments?.map((each: any) => (
                <CustomTableRowTR key={each.id}>
                  <TableData>{each?.comment}</TableData>
                  <TableData>{each?.commenterEmail}</TableData>
                  <TableData>
                    {each?.timestamp
                      ? formatDateTimeWithSeconds(each?.timestamp)
                      : "-"}
                  </TableData>
                </CustomTableRowTR>
              ))
            ) : (
              <TableRow >
                <TableHeader colSpan={4} align="center">
                  No data available
                </TableHeader>
              </TableRow>
            )}
          </TableBody>
        </StyledTable>
      </TableContainer>

      <TableTopHeader>
        <Title>Supply comments</Title>
      </TableTopHeader>

      <TableContainer component={Paper} sx={{ borderRadius: "8px" }}>
        <StyledTable>
          <TableHead>
            <TableRow
              sx={{
                backgroundColor: "rgba(232, 235, 237, 0.3) !important",
              }}
            >
              <TableHeader>Comment</TableHeader>
              <TableHeader>Commenter email</TableHeader>
              <TableHeader>Timestamp</TableHeader>
            </TableRow>
          </TableHead>
          <TableBody>
            {record?.supplyComments?.length > 0 ? (
              record?.supplyComments?.map((each: any) => (
                <CustomTableRowTR key={each.id}>
                  <TableData>{each?.comment}</TableData>
                  <TableData>{each?.commenterEmail}</TableData>
                  <TableData>
                    {each?.timestamp
                      ? formatDateTimeWithSeconds(each?.timestamp)
                      : "-"}
                  </TableData>
                </CustomTableRowTR>
              ))
            ) : (
              <TableRow>
                <TableHeader colSpan={4} align="center">
                  No data available
                </TableHeader>
              </TableRow>
            )}
          </TableBody>
        </StyledTable>
      </TableContainer>

      <TableTopHeader>
        <Title>Customer comments</Title>
      </TableTopHeader>

      <TableContainer component={Paper} sx={{ borderRadius: "8px" }}>
        <StyledTable>
          <TableHead>
            <TableRow
              sx={{
                backgroundColor: "rgba(232, 235, 237, 0.3) !important",
              }}
            >
              <TableHeader>Comment</TableHeader>
              <TableHeader>Commenter email</TableHeader>
              <TableHeader>Timestamp</TableHeader>
            </TableRow>
          </TableHead>
          <TableBody>
            {record?.customerComments?.length > 0 ? (
              record?.customerComments?.map((each: any) => (
                <CustomTableRowTR key={each.id}>
                  <TableData>{each?.comment}</TableData>
                  <TableData>{each?.commenterEmail}</TableData>
                  <TableData>
                    {each?.timestamp
                      ? formatDateTimeWithSeconds(each?.timestamp)
                      : "-"}
                  </TableData>
                </CustomTableRowTR>
              ))
            ) : (
              <TableRow>
                <TableHeader colSpan={4} align="center">
                  No data available
                </TableHeader>
              </TableRow>
            )}
          </TableBody>
        </StyledTable>
      </TableContainer>
    </TableWrapper>
  );
};

export default PartyCommentsPanel;
